export default __webpack_public_path__ + "static/media/pdfIconFile.35beccdb.png";